"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.helpers = exports.state = void 0;
var chain_1 = __importDefault(require("./chain"));
var configuration_1 = require("./configuration");
var connect_1 = __importStar(require("./connect"));
var disconnect_1 = __importDefault(require("./disconnect"));
var helpers_1 = require("./helpers");
var store_1 = require("./store");
exports.state = store_1.state;
var actions_1 = require("./store/actions");
var utils_1 = require("./utils");
var validation_1 = require("./validation");
__exportStar(require("./types"), exports);
var API = {
    connectWallet: connect_1["default"],
    disconnectWallet: disconnect_1["default"],
    setChain: chain_1["default"],
    state: {
        get: store_1.state.get,
        select: store_1.state.select,
        actions: {
            setWalletModules: actions_1.setWalletModules,
            setPrimaryWallet: actions_1.setPrimaryWallet
        }
    }
};
var helpers = {
    loadWalletModule: connect_1.loadWalletModule,
    connectWallet: connect_1.connectWallet,
    isHardwareWallet: helpers_1.isHardwareWallet
};
exports.helpers = helpers;
function init(options) {
    if (typeof window === 'undefined') {
        return API;
    }
    if (options) {
        var error = (0, validation_1.validateInitOptions)(options);
        if (error) {
            throw error;
        }
    }
    var wallets = options.wallets, chains = options.chains;
    (0, actions_1.addChains)((0, utils_1.chainIdToHex)(chains));
    (0, configuration_1.updateConfiguration)({
        initialWalletInit: wallets
    });
    return API;
}
exports["default"] = init;
